module.exports = __webpack_public_path__ + "img/ui-preview-smartbuilding.890c7a5e.jpg";